import { useTheme } from '@emotion/react';
import { type MemoExoticComponent, memo } from 'react';

import { EMPTY_STATE_ACHIEVEMENT_VARIANTS, getEmptyStateAchievementFills } from './constants';

type EmptyStateAchievementProps = {
  size?: number;
  variant?: EMPTY_STATE_ACHIEVEMENT_VARIANTS;
};

export const EmptyStateAchievementBase = ({
  size,
  variant = EMPTY_STATE_ACHIEVEMENT_VARIANTS.YELLOW,
}: EmptyStateAchievementProps) => {
  const theme = useTheme();

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 72 69"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.1758 3.87109C33.4946 0.910669 38.5054 0.91067 41.8242 3.87109L52.0518 12.9941C52.6123 13.4942 53.2223 13.9368 53.8711 14.3154L65.708 21.2227C69.5491 23.4642 71.0975 28.2306 69.3076 32.3018L63.792 44.8486C63.4897 45.5362 63.2563 46.2524 63.0967 46.9863L60.1855 60.3789C59.2406 64.7246 55.1857 67.6699 50.7607 67.2256L37.124 65.8564C36.3766 65.7814 35.6234 65.7814 34.876 65.8564L21.2393 67.2256C16.8143 67.6699 12.7594 64.7246 11.8145 60.3789L8.90332 46.9863C8.74374 46.2524 8.51031 45.5362 8.20801 44.8486L2.69238 32.3018C0.902513 28.2306 2.45093 23.4642 6.29199 21.2227L18.1289 14.3154C18.7777 13.9368 19.3877 13.4942 19.9482 12.9941L30.1758 3.87109Z"
        fill={getEmptyStateAchievementFills(theme, variant).fill}
        stroke={getEmptyStateAchievementFills(theme, variant).stroke}
        strokeWidth="2.5"
      />
    </svg>
  );
};

export const EmptyStateAchievement: MemoExoticComponent<typeof EmptyStateAchievementBase> & {
  VARIANTS?: typeof EMPTY_STATE_ACHIEVEMENT_VARIANTS;
} = memo(EmptyStateAchievementBase);

EmptyStateAchievement.VARIANTS = EMPTY_STATE_ACHIEVEMENT_VARIANTS;

export { EMPTY_STATE_ACHIEVEMENT_VARIANTS };
